



























































































































































































import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { InputText, InputNumber } from "../components/search/input";
import { MorpheusAPI } from "../iop/morpheus-api";
import { IDidDocumentData, ALL_RIGHTS, IKeyRightHistory, IOperationData, DidOperation } from '../iop/interfaces';
import { formatMorpheusSignableOperation } from '../iop/utils';

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    InputNumber,
    InputText,
  },
})
export default class MorpheusBrowserPage extends Vue {
  private did = '';
  private atHeight: number;
  private didDocument: IDidDocumentData = null;
  private operationAttempts: DidOperation[] = null;
  private tabActive = 'keys';
  private error = false;

  get rights() {
    if(!this.didDocument) {
      return [];
    }
    const rights = [];

    for(const right of ALL_RIGHTS) {
      const rightHistories: IKeyRightHistory[] = this.didDocument.rights[right];

      for(const history of rightHistories) {
        const keyIndex = history.keyLink.slice(1);
        if (this.didDocument.keys[keyIndex].valid) {
          rights.push({
            right,
            keyLink: history.keyLink,
            valid: history.valid,
          });
        }
      }
    }
    
    return rights;
  }

  get keys() {
    if(!this.didDocument) {
      return [];
    }
    const keys = [];

    for(const key of this.didDocument.keys) {
      const keyRights = [];

      for(const right of ALL_RIGHTS) {
        const rightHistories: IKeyRightHistory[] = this.didDocument.rights[right];

        for(const history of rightHistories) {
          if(
            history.keyLink.startsWith('#') && 
            parseInt(history.keyLink.substring(1), 10) === key.index &&
            history.valid
          ) {
            keyRights.push(right);
          }
        }
      }

      keys.push({
        index: key.index,
        auth: key.auth,
        validFromHeight: key.validFromHeight,
        validUntilHeight: key.validUntilHeight,
        valid: key.valid,
        rights: keyRights
      });
    }
    return keys;
  }

  get operations() {
    return this.operationAttempts.map((attempt) => {
      return {
        confirmed: attempt.valid,
        operation: formatMorpheusSignableOperation(attempt.data),
        blockHeight: attempt.blockHeight,
        transactionId: attempt.transactionId,
      };
    });
  }

  get keyColumns() {
    return [
      {
        label: 'Index', 
        field: 'index', 
        thClass: "start-cell semibold",
        tdClass: "start-cell",
      },
      {
        label: 'Auth',
        field: "auth",
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Rights',
        field: "rights",
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Valid From',
        field: "validFromHeight",
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Valid Until',
        field: "validUntilHeight",
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Valid',
        field: "valid",
        thClass: "semibold",
        tdClass: "break-all",
      },
    ];
  }

  get rightColumns() {
    return [
      {
        label: 'Right', 
        field: 'right', 
        thClass: "start-cell semibold",
        tdClass: "start-cell",
      },
      {
        label: 'Key Link',
        field: "keyLink",
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Valid',
        field: "valid",
        thClass: "semibold",
        tdClass: "break-all",
      },
    ];
  }

  get operationColumns() {
    return [
      {
        label: 'Confirmed', 
        field: 'confirmed', 
        thClass: "semibold",
        tdClass: "text-center",
      },
      {
        label: 'Operation', 
        field: 'operation', 
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'At Height', 
        field: 'blockHeight', 
        thClass: "semibold",
        tdClass: "break-all",
      },
      {
        label: 'Tx ID', 
        field: 'transactionId', 
        thClass: "semibold",
        tdClass: "break-all",
      },
    ];
  }

  get isKeysTabActive() {
    return this.tabActive === "keys";
  }

  get isRightsTabActive() {
    return this.tabActive === "rights";
  }

  get isOperationsTabActive() {
    return this.tabActive === "operations";
  }

  public async beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
    try {
      next((vm) => {
        if(to.params.did) {
          vm.did = to.params.did;
          vm.search();
        }
      });
    }
    catch(e) {
      console.log(e);
    }
  }

  private showDashIfNull(number: number|null) {
    return (number == null) ? '-' : number;
  }

  private setActiveTab(active: string) {
    this.tabActive = active;
  }

  private onDidChange(event: any): void {
    const { name, value } = event.target;
    this.did = value;
  }

  private onHeightChange(event: any): void {
    const { name, value } = event.target;
    this.atHeight = !value ? undefined : parseInt(value, 10);
  }

  private onSearchClick(): void {
    const path = `/did-browser/${this.did}`;
    if(this.did) {
      if(this.$route.path !== path) {
        this.$router.push(path);
      }
      else {
        this.search();
      }
    }
  }

  private async search(): Promise<void> {
    try {
      this.error = false;
      const results = await Promise.all([
        MorpheusAPI.getDidDocument(this.did, this.atHeight),
        MorpheusAPI.getOperationsAttempts(this.did, this.atHeight),
      ]);
      this.didDocument = results[0];
      this.operationAttempts = results[1];
    } catch(e) {
      this.error = true;
    }
  }
}
